<template>
  <div>
    <router-view v-if="authReady" :key="$route.path"></router-view>
    <div v-else class="auth-loading">
      Loading...
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      authReady: false,
      quoteInterval: null,
      lastPriceCheck: null,
      quoteFetchInFlight: false,
      pendingForceRefresh: false
    }
  },
  methods: {
    hasValidSpotPrices (body) {
      return body && body.GOLD && body.SILV && body.PLAT && body.PALL
    },
    finishSpotPriceFetch () {
      this.quoteFetchInFlight = false
      if (this.pendingForceRefresh) {
        this.getSpotPrices({ force: true })
      }
    },
    getSpotPrices (options) {
      const force = !!(options && options.force)
      if (!this.$auth.check()) {
        return
      }

      if (this.quoteFetchInFlight) {
        if (force) {
          this.pendingForceRefresh = true
        }
        return
      }
      if (!force && this.lastPriceCheck && Date.now() - this.lastPriceCheck < 5000) {
        return
      }

      this.quoteFetchInFlight = true
      this.pendingForceRefresh = false
      this.$http.get('quote/all').then(response => {
        this.lastPriceCheck = Date.now()
        if (this.hasValidSpotPrices(response.body)) {
          this.$bus.$emit('spot-price', response.body)
        }
        this.finishSpotPriceFetch()
      }, response => {
        console.log(response)
        this.finishSpotPriceFetch()
      })
    },
    userDetails () {
      if (this.$auth.check()) {
        this.$http.get('auth/userDetails').then(response => {
          if (response.body && response.body.message) {
            this.$router.push({ path: '/login' })
          }
        }, response => {
          console.log(response)
        })
      }
    }
  },
  beforeMount () {
    this.getSpotPrices()
  },
  mounted () {
    this.quoteInterval = window.setInterval(() => {
      this.getSpotPrices()
      this.userDetails()
    }, 10000)
  },
  beforeDestroy () {
    clearInterval(this.quoteInterval)
  },
  created () {
    if (this.$auth.ready()) {
      this.authReady = true
    } else {
      this.$auth.ready(() => {
        this.authReady = true
      })
    }

    this.$bus.$on('request-spot-price', ($event) => {
      this.getSpotPrices($event || {})
    })
  }
}
</script>

<style lang="scss" scoped>
.auth-loading {
  padding: 2rem;
  text-align: center;
  font-size: 1.25rem;
}
</style>

<style lang="scss">
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/css/font-awesome.min.css';
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/css/simple-line-icons.css';
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  @import '../scss/style';
</style>



// WEBPACK FOOTER //
// src/App.vue